import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../../../actionTypes';

const initialState = false;

const show = () => true;
const hide = () => false;

export default createReducer(initialState, {
  [types.DISPLAY_TARGET_MODAL]: show,
  [types.HIDE_TARGET_MODAL]: hide,
  [types.ACTIVATE_AUDIT_MODEL_SUCCESS]: hide,
});
